"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Used to wrap `<CardActionButton>` components when mixing buttons
 * and icons in the same set of actions.
 */


var CardActionButtons = function CardActionButtons(_ref) {
  var className = _ref.className,
      other = _objectWithoutProperties(_ref, ["className"]);

  return _react2.default.createElement("div", _extends({
    className: (0, _classnames2.default)("mdc-card__action-buttons", className)
  }, other));
};

exports.default = CardActionButtons;